import React, { FC, ReactNode, Suspense } from 'react';
import Loader from '../Loader';

interface ILazySuspenseProps {
  children: ReactNode;
  customFallbackChild?: ReactNode;
}

const LazySuspense: FC<ILazySuspenseProps> = (props) => {
  const { children, customFallbackChild } = props;

  return (
    <Suspense
      fallback={
        customFallbackChild ? (
          customFallbackChild
        ) : (
          <Loader fullscreen />
        )
      }
    >
      {children}
    </Suspense>
  );
};

export default LazySuspense;
